<template>
    <Modal v-model="show"
        title="账号信息"
        :width="60"
        @on-visible-change="onShowChange">
        <Spin v-if="$globalSpin"
            size="large"
            fix></Spin>
        <Form ref="userDistributionStationForm"
            :model="userDistributionStationForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form">

            <Row :gutter="16">
                <Col span="6">
                <FormItem label="登录账号"
                    prop="userName">
                    <Input v-model="userDistributionStationForm.userName"
                        :readonly="formEditMode===FORM_EDIT_MODE_MODIFY"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="姓名"
                    prop="userDistributionStationName">
                    <Input v-model="userDistributionStationForm.userDistributionStationName"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="所属转运站"
                    prop="userDistributionStationRelateStationUuid">
                    <Select v-model="userDistributionStationForm.userDistributionStationRelateStationUuid"
                        filterable>
                        <Option v-for="(item,index) in distributionStationSource"
                            :key="index"
                            :value="item.distributionStationUuid">{{item.distributionStationCode + ' - '+ item.distributionStationName }}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="手机"
                    prop="userDistributionStationPhone">
                    <Input v-model="userDistributionStationForm.userDistributionStationPhone"></Input>
                </FormItem>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="6">
                <FormItem label="审批">
                    <RadioGroup v-model="userDistributionStationForm.userDistributionStationApproval"
                        type="button">
                        <Radio v-for="item in approvalSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码">
                    <Input v-model="password"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码确认">
                    <Input v-model="passwordConfirm"
                        type="password"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary"
                @click="onSave">确认</Button>
            <Button type="error"
                @click="onCancel">取消</Button>
        </div>
    </Modal>
</template>

<script>
import { APPROVAL_NO, APPROVAL_YES, approvalFormat } from '@/libs/baseModelFormat';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import {
    distributionStationUserSave,
    getDistributionStationUserDetail,
    pageInit4UserDistributionStationEdit
} from '@/api/modules/account-management/distributionStation-user-management';
import { Row } from 'iview';

export default {
    name: 'DistributionStationUserEdit', 
    data() {
        return {
            show: false,
            accountUuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userDistributionStationForm: {
                userDistributionStationLoginUuid: '',
                userName: '',
                userDistributionStationName: '',
                userDistributionStationRelateStationUuid: '',
                userDistributionStationContactNumber: '',
                userDistributionStationPhone: '',
                userDistributionStationWechat: '',
                userDistributionStationEmail: '',
                userDistributionStationApproval: APPROVAL_NO
            },
            ruleValidate: {
                userName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: this.validateUserName
                    }
                ],
                userDistributionStationName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: this.validateUserName
                    }
                ],
                userDistributionStationRelateStationUuid: [
                    { required: true, message: ' ', trigger: 'blur' }
                ],
                userDistributionStationPhone: [
                    { pattern: /^(?:(?:\+|00)86)?1\d{10}$/, required: true, message: '手机号码格式不正确', trigger: 'blur' }
                ]
            },
            password: '',
            passwordConfirm: '',
            distributionStationSource: [],
            approvalSource: []
        };
    },
    mounted() {
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
            else {
                this.$hideGlobalSpin();
            }
        },
        showModal(accountUuid) {
            this.accountUuid = accountUuid;
            this.show = true;
        },
        init() {
            this.initApprovalSource();
            this.loadDistributionStations();
            
            if (this.accountUuid) {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;
                this.loadUserDetail();
            }
            else {
                this.$nextTick(() => {
                    if (this.$refs.userDistributionStationForm) {
                        this.$refs.userDistributionStationForm.resetFields();
                    }
                });
                this.password = '';
                this.passwordConfirm = '';
            }
        },
        initApprovalSource() {
            this.approvalSource = [
                { val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) },
                { val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) }
            ];
        },
        loadDistributionStations() {
            //this.$showGlobalSpin();
            pageInit4UserDistributionStationEdit().then(res => {
                if (res && res.code === 0) {
                    console.log("res.data.distributionStation", res.data.distributionStation);
                    this.distributionStationSource = res.data.distributionStation.records.map(item => ({
                        distributionStationUuid: item.distributionStationUuid,
                        distributionStationName: item.distributionStationName,
                        distributionStationCode: item.distributionStationCode
                    }));
                }
                else {
                    this.$Message.error((res && res.message) || '获取转运站列表失败');
                    this.distributionStationSource = [];
                }
            }).catch(error => {
                console.error('获取转运站列表失败:', error);
                this.$Message.error('获取转运站列表失败');
                this.distributionStationSource = [];
            }).finally(() => {
                //this.$hideGlobalSpin();
            });
        },
        loadUserDetail() {
            this.$showGlobalSpin();
            getDistributionStationUserDetail(this.accountUuid).then(detail => {
                if (detail.code === 0) {
                    const info = detail.data.userDistributionStation;
                    Object.assign(this.userDistributionStationForm, {
                        userDistributionStationLoginUuid: info.userDistributionStationLoginUuid,
                        userName: info.userName,
                        userDistributionStationName: info.userDistributionStationName,
                        userDistributionStationRelateStationUuid: info.userDistributionStationRelateStationUuid,
                        userDistributionStationContactNumber: info.userDistributionStationContactNumber,
                        userDistributionStationPhone: info.userDistributionStationPhone,
                        userDistributionStationWechat: info.userDistributionStationWechat,
                        userDistributionStationEmail: info.userDistributionStationEmail,
                        userDistributionStationApproval: info.userDistributionStationApproval
                    });
                }
                else {
                    this.$Message.error(detail.message || '获取用户详情失败');
                }
            }).catch(error => {
                console.error('获取用户详情失败:', error);
                this.$Message.error('获取用户详情失败');
            }).finally(() => {
                this.$hideGlobalSpin();
            });
        },
        validateUserName(rule, value, callback) {
            if (!value) {
                callback(new Error('不能为空'));
                return;
            }
            const minLength = rule.field === 'userName' ? 3 : 2;
            const maxLength = 20;
            if (value.length >= minLength && value.length <= maxLength) {
                callback();
            }
            else {
                callback(new Error(`长度在${minLength}-${maxLength}个字符之间`));
            }
        },
        onCancel() {
            this.$hideGlobalSpin();
            this.show = false;
        },
        onSave() {
            this.$refs.userDistributionStationForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                    if (!this.password) {
                        this.$Message.error('请输入密码');
                        return;
                    }
                    if (this.password !== this.passwordConfirm) {
                        this.$Message.error('两次输入的密码不一致');
                        return;
                    }
                }

                const data = Object.assign({ formEditMode: this.formEditMode }, this.userDistributionStationForm);
                if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                    data.password = this.password;
                    data.passwordConfirm = this.passwordConfirm;
                }

                this.$showGlobalSpin();
                distributionStationUserSave(data).then(res => {
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$parent.getDistributionStationUserTableRecords();
                            }
                        });
                    }
                    else {
                        this.$Message.error(res.message || '保存失败');
                    }
                }).catch(error => {
                    console.error('保存失败:', error);
                    this.$Message.error('保存失败');
                }).finally(() => {
                    this.$hideGlobalSpin();
                });
            });
        }
    }
};
</script>

<style scoped>
</style>
